import styled from "styled-components";
import { BodyDefault, BodyMedium, HeadLine2 } from "../../../../components/typography/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: 'InterVariable', 'Inter', sans-serif;
  margin-top: 30px;
`

export const ContainerTitle = styled(HeadLine2)`
  color:${({theme}) => theme.neutral[100]};
  z-index: 3;
  margin-bottom:10px;
`

export const ServicesWrapper = styled.div`
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap:10px;

  /* flex: 1 1 160px; */
`
type ItemProp = {
  disabled?:boolean;
}
export const ServiceItem = styled.div<ItemProp>`
  display: flex;
  box-sizing: border-box;
  padding: 14px 20px;
  /* width:33%; */
  text-decoration: none;
  gap: 10px;
  width: calc((100% - 20px) / 3);
  min-height: 92px;
  border: 0;
  border-radius: 14px;
  flex: 0 0 calc((100% - 20px) / 3);
  opacity: ${({disabled}) => disabled ? '0.5' : '1'};
  background-color: ${({theme}) => theme.palette[10]};
  box-shadow: ${({theme}) => theme.isDark
    ? theme.shadows.card
    : '0px 4px 30px rgba(186, 196, 211, 0.2)'};

  &:nth-child(5) > img {
    width: 24px;
    height: 24px;
  }
  /* flex-basis: 33.33333%; */
  &:hover {
    cursor: pointer;
    background: ${({theme, disabled}) => disabled ? '' : theme.isDark ? theme.palette[200] : theme.grey[100]};
  }
  &:active{
    background-color: ${({theme, disabled}) => disabled ? '' : theme.isDark ? theme.palette[400] : theme.grey[200]};
    transition: 0.1s background-color ease-in-out;
  }

  @media screen and (max-width: 900px) {
    width: calc((100% - 10px) / 2);
    flex-basis: calc((100% - 10px) / 2);
  }

  @media screen and (max-width: 600px) {
    width: 100%;
    flex-basis: 100%;
  }
`

export const IconService = styled.img`
  width:20px;
  height:20px;
  flex-shrink: 0;
`
export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ServiceTitle = styled(BodyMedium)`
  color:${({theme}) => theme.icon.primary};
  display: flex;
  align-items: center;
  gap:6px;
`

export const ServiceSubTitle = styled(BodyDefault)`
  color:${({theme}) => theme.neutral[80]};
`

export const SoonText = styled.div`
  /* font-family: 'Inter'; */
  font-style: normal;
  font-weight: 500;
  font-size: 8px;
  white-space: nowrap;
  background-color: ${({theme}) => theme.grey[300]};
  line-height: 12px;
  text-transform: uppercase;
  color:${({theme}) => theme.palette[800]};
  border-radius: 4px;
  padding: 2px;
`
